
   (function () {
    'use strict';
  
    /* ── DOM helpers ── */
    const $ = (sel, ctx = document) => ctx.querySelector(sel);
    const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  
    /* ── Money formatting ── */
    function formatMoney(cents) {
      const currencyCode =
        (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
        window.shopCurrencyCode ||
        'GBP';
      try {
        return (cents / 100).toLocaleString(undefined, {
          style: 'currency',
          currency: currencyCode,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      } catch (_) {
        return '£' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
    }
  
    /* ── Build a single cart item HTML ── */
    function buildItemHTML(item) {
      const image = item.image
        ? `<img src="${item.image}" alt="${escapeHTML(item.product_title)}" width="80" height="80" class="product-image-photo" loading="lazy">`
        : `<div class="product-image-placeholder" style="width:80px;height:80px;background:#f5f5f5;"></div>`;

      let optionsHTML = '';
      if (item.options_with_values && item.options_with_values.length) {
        const rows = item.options_with_values
          .filter(o => o.value && o.value !== 'Default Title')
          .map(o => `<dl class="product-attributes"><dt class="label">${escapeHTML(o.name)}</dt><dd class="values">${escapeHTML(o.value)}</dd></dl>`)
          .join('');

        if (rows) {
          optionsHTML = `
            <div class="product options">
              <span class="toggle see-details-toggle" data-action="toggle-details">
                See Details
                <svg class="toggle-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 6" width="10" height="6">
                  <path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span>
              <div class="content details-content" style="display:none;">
                <strong class="subtitle">Options Details</strong>
                ${rows}
              </div>
            </div>`;
        }
      }

      const basePrice = item.final_line_price / item.quantity;
      const itemTotal = basePrice + hulkUnitTotal(item);

      return `
        <li class="item product product-item" data-cart-item data-cart-item-key="${item.key}"
          data-cart-item-product-id="${item.product_id}"
          data-cart-item-title="${escapeHTML(item.product_title)}"
          data-cart-item-variant="${escapeHTML(item.variant_title || '')}"
          data-cart-item-price="${itemTotal / 100}"
        >
          <div class="product">
            <a href="${item.url}" class="product-image-container">${image}</a>
            <div class="product-item-details">
              <a class="product-item-name" href="${item.url}">${escapeHTML(item.product_title)}</a>
              ${optionsHTML}
              <div class="pricing">
                <span class="product-item-price">${formatMoney(itemTotal)}</span>
              </div>
              <div class="details-qty">
                <div class="details-qty__input">
                  <label class="label" for="cart-item-qty-${item.key}">Qty:</label>
                  <input
                    class="cart-item-qty"
                    id="cart-item-qty-${item.key}"
                    type="number"
                    value="${item.quantity}"
                    min="1"
                    data-item-key="${item.key}"
                    data-original-qty="${item.quantity}"
                  >
                  <button class="action update" type="button" data-action="update-qty" data-item-key="${item.key}" aria-label="Update" style="display: none;">
                    <span>Update</span>
                  </button>
                </div>
                <div class="minicart-item__buttons">
                  <a class="action edit" href="${item.url}&edit_cart_item=${item.key}&qty=${item.quantity}">Edit</a>
                  <a class="action delete" href="#" data-action="remove-item" data-item-key="${item.key}" aria-label="Remove item">
                    <span>Remove</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </li>`;
    }
  
    function escapeHTML(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    /* ── Extract Hulk options price from a single property value ── */
    /* Mirrors the Liquid logic: find content between [ ], strip currency  */
    /* symbols/signs/spaces/commas, then parse what remains as a number.   */
    /* Hulk writes this amount in plain shop-currency (GBP) — it is never  */
    /* converted by Shopify, so Shopify.currency.rate has to be applied    */
    /* here or the Hulk portion of the total stays in GBP terms.          */
    function shopifyCurrencyRate() {
      const rate = window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate);
      return rate > 0 ? rate : 1;
    }

    function parseHulkPrice(value) {
      if (typeof value !== 'string') return 0;
      const m = value.match(/\[([^\]]+)\]/);
      if (!m) return 0;
      const clean = m[1].replace(/[£$€¥₹+,\s]/g, '');
      if (!/^\d+\.?\d*$/.test(clean)) return 0;
      const price = parseFloat(clean);
      return price > 0 ? Math.round(price * 100 * shopifyCurrencyRate()) : 0;
    }

    /* ── Sum all Hulk option prices for one cart item (per unit) ── */
    function hulkUnitTotal(item) {
      if (!item.properties) return 0;
      return Object.values(item.properties).reduce(
        (sum, val) => sum + parseHulkPrice(val), 0
      );
    }
  
    /* ── Fetch cart from Shopify ── */
    async function fetchCart() {
      const res = await fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } });
      return res.json();
    }

    /* ── Show error modal ── */
    function showErrorModal(message) {
      // Remove existing modal if present
      const existing = document.querySelector('.minicart-error-modal');
      if (existing) existing.remove();

      const modal = document.createElement('div');
      modal.className = 'minicart-error-modal';
      modal.innerHTML = `
        <div class="minicart-error-overlay"></div>
        <div class="minicart-error-content">
          <button class="minicart-error-close action-close" aria-label="Close">&times;</button>
          <h3>Attention</h3>
          <p>The requested qty is not available</p>
          <button class="minicart-error-ok">OK</button>
        </div>
      `;

      document.body.appendChild(modal);

      const closeModal = () => {
        modal.remove();
      };

      modal.querySelector('.minicart-error-close').addEventListener('click', closeModal);
      modal.querySelector('.minicart-error-ok').addEventListener('click', closeModal);
      modal.querySelector('.minicart-error-overlay').addEventListener('click', closeModal);
    }

    /* ── Show delete confirmation modal ── */
    function showDeleteConfirmation() {
      return new Promise((resolve) => {
        const modal = document.querySelector('[data-delete-modal]');
        if (!modal) {
          resolve(false);
          return;
        }

        modal.style.display = 'flex';

        const closeModal = (confirmed) => {
          modal.style.display = 'none';
          resolve(confirmed);
        };

        const handleConfirm = () => closeModal(true);
        const handleCancel = () => closeModal(false);

        const confirmBtn = modal.querySelector('[data-delete-confirm]');
        const cancelBtn = modal.querySelector('[data-delete-cancel]');
        const closeBtn = modal.querySelector('[data-delete-close]');
        const overlay = modal.querySelector('[data-delete-overlay]');

        // Remove old event listeners by cloning and replacing
        const newConfirmBtn = confirmBtn.cloneNode(true);
        const newCancelBtn = cancelBtn.cloneNode(true);
        const newCloseBtn = closeBtn.cloneNode(true);
        const newOverlay = overlay.cloneNode(true);

        confirmBtn.parentNode.replaceChild(newConfirmBtn, confirmBtn);
        cancelBtn.parentNode.replaceChild(newCancelBtn, cancelBtn);
        closeBtn.parentNode.replaceChild(newCloseBtn, closeBtn);
        overlay.parentNode.replaceChild(newOverlay, overlay);

        newConfirmBtn.addEventListener('click', handleConfirm);
        newCancelBtn.addEventListener('click', handleCancel);
        newCloseBtn.addEventListener('click', handleCancel);
        newOverlay.addEventListener('click', handleCancel);

        // Close on Escape key
        const handleEscape = (e) => {
          if (e.key === 'Escape') {
            handleCancel();
            document.removeEventListener('keydown', handleEscape);
          }
        };
        document.addEventListener('keydown', handleEscape);
      });
    }
  
    /* ── Update quantity ── */
    async function changeQty(key, quantity) {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });

      if (!res.ok) {
        const error = await res.json().catch(() => ({}));
        throw { status: res.status, message: error.message || error.description || 'Unable to update quantity' };
      }

      const cart = await res.json();
      return cart;
    }
  
    /* ── Re-render minicart contents ── */
    function renderCart(cart) {
      const wrapper = document.querySelector('.minicart-wrapper');
      if (!wrapper) return;

      /* Toggle is-empty class on wrapper */
      wrapper.classList.toggle('is-empty', cart.item_count === 0);

      /* Badge on the cart icon */
      const countBadge = $('[data-minicart-count]', wrapper);
      if (countBadge) {
        countBadge.querySelector('.counter-number').textContent = cart.item_count;
        countBadge.classList.toggle('empty', cart.item_count === 0);
      }
  
      /* Header: items-total count span */
      const countSpan = $('[data-minicart-count-text]', wrapper);
      if (countSpan) {
        countSpan.textContent = cart.item_count;
        /* also update the text node after the span */
        const countDiv = countSpan.closest('.items-total');
        if (countDiv) {
          countDiv.innerHTML = `<span class="count" data-minicart-count-text>${cart.item_count}</span>&nbsp;${cart.item_count === 1 ? 'Item' : 'Items'} in Cart`;
        }
      }
  
      /* Header: subtotal price */
      const subtotalPrice = $('[data-minicart-subtotal]', wrapper);
      if (subtotalPrice) {
        const hulkGrandTotal = (cart.items || []).reduce(
          (sum, item) => sum + hulkUnitTotal(item) * item.quantity, 0
        );
        subtotalPrice.textContent = formatMoney(cart.total_price + hulkGrandTotal);
      }
  
      /* Items list */
      const itemsList = $('[data-minicart-items]', wrapper);
      if (!itemsList) return;

      if (cart.item_count === 0 || !cart.items || cart.items.length === 0) {
        itemsList.innerHTML = `<li class="item empty"><span class="subtitle empty">You have no items in your shopping cart.</span></li>`;
      } else {
        itemsList.innerHTML = cart.items.map(buildItemHTML).join('');
      }
  
      attachItemEvents(wrapper);
    }
  
    /* ── Toggle "See Details" ── */
    function attachDetailsToggle(scope) {
      $$(  '[data-action="toggle-details"]', scope).forEach(toggle => {
        toggle.addEventListener('click', function () {
          const content = this.parentElement.querySelector('.details-content');
          if (!content) return;
          const isOpen = content.style.display !== 'none';
          content.style.display = isOpen ? 'none' : 'block';
          this.classList.toggle('open', !isOpen);
        });
      });
    }
  
    /* ── Attach update / remove events on items ── */
    function attachItemEvents(scope) {
      attachDetailsToggle(scope);

      /* Show/hide update button on input change */
      $$('.cart-item-qty', scope).forEach(input => {
        input.addEventListener('input', function () {
          const key = this.dataset.itemKey;
          const updateBtn = scope.querySelector(`[data-action="update-qty"][data-item-key="${key}"]`);
          const originalQty = parseInt(this.dataset.originalQty || this.defaultValue, 10);
          const currentQty = parseInt(this.value, 10);

          if (updateBtn && currentQty !== originalQty && currentQty >= 1) {
            updateBtn.style.display = 'inline-block';
          } else if (updateBtn) {
            updateBtn.style.display = 'none';
          }
        });
      });

      /* Update qty */
      $$('[data-action="update-qty"]', scope).forEach(btn => {
        btn.addEventListener('click', async function () {
          const key = this.dataset.itemKey;
          const input = scope.querySelector(`[data-item-key="${key}"].cart-item-qty`);
          const qty = parseInt(input ? input.value : 1, 10);
          scope.classList.add('loading');
          try {
            const cart = await changeQty(key, qty);
            if (cart && typeof cart === 'object') {
              renderCart(cart);
            } else {
              console.error('Invalid cart response:', cart);
              const freshCart = await fetchCart();
              renderCart(freshCart);
            }
          } catch (error) {
            console.error('Error updating cart:', error);
            if (error.status === 422) {
              showErrorModal(error.message || 'The requested quantity is not available.');
              const freshCart = await fetchCart();
              renderCart(freshCart);
            } else {
              showErrorModal('An error occurred while updating the cart. Please try again.');
            }
          } finally {
            scope.classList.remove('loading');
          }
        });
      });

      /* Remove item */
      $$('[data-action="remove-item"]', scope).forEach(btn => {
        btn.addEventListener('click', async function (e) {
          e.preventDefault();

          // Show confirmation modal
          const confirmed = await showDeleteConfirmation();
          if (!confirmed) {
            return; // User cancelled
          }

          const key = this.dataset.itemKey;
          const itemEl = scope.querySelector(`[data-cart-item-key="${key}"]`);
          const qtyInput = itemEl ? itemEl.querySelector('.cart-item-qty') : null;
          const removedQty = qtyInput ? parseInt(qtyInput.value, 10) : 1;

          scope.classList.add('loading');
          try {
            const cart = await changeQty(key, 0);
            if (cart && typeof cart === 'object') {
              if (window.Analytics && itemEl) {
                const price = parseFloat(itemEl.dataset.cartItemPrice) || 0;
                window.Analytics.pushEcommerceEvent('remove_from_cart', {
                  currency: window.shopCurrencyCode,
                  value: price * removedQty,
                  items: [{
                    item_id: itemEl.dataset.cartItemProductId,
                    item_name: itemEl.dataset.cartItemTitle,
                    item_variant: itemEl.dataset.cartItemVariant,
                    price: price,
                    quantity: removedQty
                  }]
                });
              }
              renderCart(cart);
            } else {
              console.error('Invalid cart response:', cart);
              const freshCart = await fetchCart();
              renderCart(freshCart);
            }
          } catch (error) {
            console.error('Error removing item:', error);
          } finally {
            scope.classList.remove('loading');
          }
        });
      });
    }
  
    /* ── Open / close the minicart panel ── */
    function openMinicart(wrapper) {
      const panel = wrapper.querySelector('[data-minicart-panel]');
      if (!panel) return;
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      wrapper.querySelector('.action.showcart').setAttribute('aria-expanded', 'true');
      // view_cart isn't fired here: the cart page is only ever reached via
      // this drawer's "View and Edit Cart" link, so tracking it here too
      // would double-count every cart view. See assets/cart.js instead.
    }
  
    function closeMinicart(wrapper) {
      const panel = wrapper.querySelector('[data-minicart-panel]');
      if (!panel) return;
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      wrapper.querySelector('.action.showcart').setAttribute('aria-expanded', 'false');
    }
  
    /* ── Init ── */
    document.addEventListener('DOMContentLoaded', function () {
      const wrapper = document.querySelector('.minicart-wrapper');
      if (!wrapper) return;
  
      const trigger = wrapper.querySelector('[data-action="toggle-minicart"]');
      const panel   = wrapper.querySelector('[data-minicart-panel]');
  
      /* Toggle on cart icon click */
      if (trigger) {
        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          const isOpen = panel.classList.contains('is-open');
          if (isOpen) {
            closeMinicart(wrapper);
          } else {
            openMinicart(wrapper);
          }
        });
      }
  
      /* Close button */
      const closeBtn = wrapper.querySelector('[data-action="close-minicart"]');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => closeMinicart(wrapper));
      }
  
      /* Close on outside click */
      document.addEventListener('click', function (e) {
        if (!wrapper.contains(e.target)) {
          closeMinicart(wrapper);
        }
      });
  
      /* Keyboard: Escape to close */
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeMinicart(wrapper);
      });
  
      /* Attach item events on initial load */
      attachItemEvents(wrapper);

      /* Re-render with corrected (currency-converted) totals on load.
         The server-rendered markup can't apply Shopify.currency.rate to the
         Hulk option surcharge, so refresh once client-side to fix it up. */
      if (!wrapper.classList.contains('is-empty')) {
        fetchCart().then(renderCart).catch(function (err) {
          console.error('[Minicart] Error refreshing cart on load:', err);
        });
      }
  
      /* ── Intercept add-to-cart form: AJAX add, then show minicart ── */
      document.addEventListener('submit', async function (e) {
        const form = e.target;

        /* Only handle product add-to-cart forms */
        const isAddToCart = form.matches('form[action="/cart/add"], form[action="/cart/add/"]')
          || (form.action && form.action.includes('/cart/add'));
        if (!isAddToCart) return;

        /* Prevent the default page redirect */
        e.preventDefault();

        const submitBtn = form.querySelector('[type="submit"], [name="add"]');
        const urlParams = new URLSearchParams(window.location.search);
        const editCartItemKey = urlParams.get('edit_cart_item');

        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.dataset.originalText = submitBtn.textContent;
          submitBtn.textContent = editCartItemKey ? 'Updating…' : 'Adding…';
        }
        wrapper.classList.add('loading');

        try {
          /* Check if we're editing an existing cart item */
          const urlParams = new URLSearchParams(window.location.search);
          const editCartItemKey = urlParams.get('edit_cart_item');

          /* If editing, remove the old item first */
          if (editCartItemKey) {
            await changeQty(editCartItemKey, 0);
          }

          /* POST form data to /cart/add.js */
          const formData = new FormData(form);
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            body: formData
          });

          if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            const msg = err.description || err.message || 'Could not add item to cart. Please try again.';
            alert(msg);
            return;
          }

          const addedItem = await res.json();

          if (window.Analytics) {
            // addedItem.price is the plain variant price — it doesn't include
            // the Hulk custom-option surcharge, since that only ever exists
            // as a line item property, not a real price change Shopify's own
            // cart API knows about.
            const unitPrice = window.Analytics.toDecimal(addedItem.price) + window.Analytics.toDecimal(hulkUnitTotal(addedItem));
            window.Analytics.pushEcommerceEvent('add_to_cart', {
              currency: window.shopCurrencyCode,
              value: unitPrice * addedItem.quantity,
              items: [{
                item_id: addedItem.product_id,
                item_name: addedItem.product_title,
                item_variant: addedItem.variant_title,
                price: unitPrice,
                quantity: addedItem.quantity
              }]
            });
          }

          /* Fetch fresh cart state and render */
          const cart = await fetchCart();
          renderCart(cart);
          openMinicart(wrapper);

        } catch (err) {
          console.error('[Minicart] Add to cart error:', err);
        } finally {
          wrapper.classList.remove('loading');
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = submitBtn.dataset.originalText || 'Add to Basket';
          }
        }
      });
  
      /* ── Global helper: call after any custom AJAX add-to-cart ── */
      window.MinicartRefresh = async function () {
        const cart = await fetchCart();
        renderCart(cart);
        openMinicart(wrapper);
      };
  
      /* ── cart:refresh custom event support ── */
      document.addEventListener('cart:refresh', async function () {
        const cart = await fetchCart();
        renderCart(cart);
      });


      // checkout button spinner logic
      const checkoutButton = document.getElementById('top-cart-btn-checkout');
      const checkoutForm = document.getElementById('minicart-checkout-form');

      checkoutForm.addEventListener('click', function() {
        checkoutButton.classList.add('is-loading');

        if (window.Analytics) {
          const items = $$('[data-cart-item]', wrapper).map(function (el) {
            const qtyInput = el.querySelector('.cart-item-qty');
            return {
              item_id: el.dataset.cartItemProductId,
              item_name: el.dataset.cartItemTitle,
              item_variant: el.dataset.cartItemVariant,
              price: parseFloat(el.dataset.cartItemPrice) || 0,
              quantity: qtyInput ? parseInt(qtyInput.value, 10) : 1
            };
          });
          const value = items.reduce(function (sum, it) { return sum + it.price * it.quantity; }, 0);
          window.Analytics.pushEcommerceEvent('begin_checkout', {
            currency: window.shopCurrencyCode,
            value: value,
            items: items
          });
        }
      });

    });
  
  })();
  